import { gql } from '@apollo/client';

export const GET_CHECKOUTCOM_PAYMENT_DETAILS = gql`
  query getCheckoutComPaymentDetailsQuery($paymentSessionId: String!) {
    getCheckoutComPaymentDetails(paymentSessionId: $paymentSessionId) {
      id
      payment_type
      status
      approved
      actions {
        id
        type
        response_code
        response_summary
      }
      threeDS {
        downgraded
        enrolled
        authentication_response
        version
        exemption
        challenged
        exemption_applied
      }
    }
  }
`;
